function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import isEqual from 'lodash/isEqual';
import Event from './utils/event';
import './utils/string-template2';
var CURRENT_LOCALE_CODE;
var CURRENT_LOCALE_BUNDLE = {};
var languageChangeEvent = new Event();
export function setLanguageBundle(_x, _x2) {
  return _setLanguageBundle.apply(this, arguments);
}

function _setLanguageBundle() {
  _setLanguageBundle = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(localeCode, bundle) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            CURRENT_LOCALE_CODE = localeCode;
            CURRENT_LOCALE_BUNDLE = bundle;
            languageChangeEvent.fire({
              localeCode: localeCode,
              bundle: bundle
            });
            return _context.abrupt("return", {
              locale: CURRENT_LOCALE_CODE,
              bundle: CURRENT_LOCALE_BUNDLE
            });

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _setLanguageBundle.apply(this, arguments);
}

export function updateLanguageBundle(_x3) {
  return _updateLanguageBundle.apply(this, arguments);
}

function _updateLanguageBundle() {
  _updateLanguageBundle = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(bundlePatch) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            CURRENT_LOCALE_BUNDLE = _objectSpread(_objectSpread({}, CURRENT_LOCALE_BUNDLE), bundlePatch);
            languageChangeEvent.fire({
              CURRENT_LOCALE_CODE: CURRENT_LOCALE_CODE,
              CURRENT_LOCALE_BUNDLE: CURRENT_LOCALE_BUNDLE,
              localeCode: CURRENT_LOCALE_CODE,
              bundle: CURRENT_LOCALE_BUNDLE
            });
            return _context2.abrupt("return", {
              locale: CURRENT_LOCALE_CODE,
              bundle: CURRENT_LOCALE_BUNDLE
            });

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _updateLanguageBundle.apply(this, arguments);
}

export function getString(key, replaceOptions) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var value;

  if (attributes) {
    for (var keyName in CURRENT_LOCALE_BUNDLE) {
      if (key === keyName && Array.isArray(CURRENT_LOCALE_BUNDLE[key])) {
        CURRENT_LOCALE_BUNDLE[key].some(function (key) {
          return isEqual(key.attributes, attributes) ? value = key.value : null;
        });
      }
    }
  } else {
    value = CURRENT_LOCALE_BUNDLE[key];
  } // do replacement


  if (typeof value !== 'string') {
    return "Missing locale value (".concat(key, ")");
  }

  return replaceOptions ? value.template(replaceOptions) : value;
}
export function getStringJSXReplaceOptions(key, replaceOptions) {
  var value = CURRENT_LOCALE_BUNDLE[key]; //do replacement

  if (typeof value !== 'string') {
    return "Missing locale value (".concat(key, ")");
  }

  var returnString = value;
  Object.keys(replaceOptions).map(function (option) {
    returnString = returnString.replace(new RegExp(option, 'g'), replaceOptions[option]);
  });
  return returnString;
}
export function keyExists(key) {
  return !!CURRENT_LOCALE_BUNDLE[key];
}
export { CURRENT_LOCALE_BUNDLE, CURRENT_LOCALE_CODE, languageChangeEvent };
//# sourceMappingURL=translations.js.map